import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CenterPackageReport from "../components/CenterPackageReport";
const StateOverviewPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout >

        {/* Breadcrumb */}
        <Breadcrumb title="Centers Packages Overview" />

        <CenterPackageReport />

      </MasterLayout>
    </>
  );
};

export default StateOverviewPage;
